module.exports = __webpack_public_path__ + "img/中国化工体育协会@3x.fab2ecb4.png";